var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length)?_c('b-breadcrumb',_vm._l((_vm.items),function(item,index){return _c('b-breadcrumb-item',{key:index,attrs:{"to":item.href,"active":index === _vm.items.length - 1}},[_vm._v(" "+_vm._s(item.label)+" ")])}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }